import api from 'api';
import { ResponseOrError, wrapError, wrapSuccess } from 'lib/types/responses';
import { logAndCaptureException } from 'utils';
import { ERequestTypes } from 'lib/types';
import { OrderModel } from 'lib/model/objects/orderModel';
import { ColumnService } from 'lib/services/directory';
import { logInfo } from 'utils/logger';

export const sendCancelOrderRequest = async (
  cancellationReason: string,
  order: OrderModel,
  anonymousUserAuthInfo: { authEmail: string; accessCode: string } | undefined
): Promise<ResponseOrError<void>> => {
  const { product } = order.modelData;
  const reqBody: ERequestTypes['orders/cancel'] = {
    orderId: order.id,
    cancellationReason,
    anonymousUserAuthInfo: anonymousUserAuthInfo ?? null
  };
  const logData = {
    orderId: order.id,
    cancellationReason,
    product
  };
  const { error } = await api.safePost('orders/cancel', reqBody);

  if (error) {
    const errObj = new Error(error);
    logAndCaptureException(
      ColumnService.ORDER_MANAGEMENT,
      errObj,
      'Error cancelling order',
      {
        orderId: order.id
      }
    );
    return wrapError(errObj);
  }

  logInfo('Successfully canceled order', logData);

  return wrapSuccess(undefined);
};
